// extracted by mini-css-extract-plugin
module.exports = {"editor":"CustomTextEditor_editor__3-xID","scale":"CustomTextEditor_scale__58Xy0","htmlText":"CustomTextEditor_htmlText__3gWSr","j_editor":"CustomTextEditor_j_editor__Qmw1s"};